import styled, { css } from 'styled-components';
import { StyledFilterBlock } from '../../forms/Candidates/Filters.form';
import { StyledCard } from '../../../components/Card.component';
import { StyledTableRows } from '../../../components/Table/Table.component';
import { StyledFloatButton } from '../../../components/FloatButton.component';
import {
  MINI_CHAT_MOBILE_HEIGHT,
  MINI_CHAT_TRANSITION_MS,
  MINI_CHAT_WIDTH,
} from './components/CandidatesMiniChat/CandidatesMiniChat.styles';

export const StyledCandidatesPageWithFilters = css`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 22px;

  ${StyledFilterBlock} {
    height: 100%;
  }
`;

export const StyledCandidatesPage = styled.div<{
  filterBlock: boolean;
}>`
  padding: 22px;

  ${StyledCard} {
    max-height: calc(100vh - 44px - 61px);
    overflow: hidden;

    &:not(${StyledFilterBlock}) {
      display: flex;
      flex-direction: column;
    }
  }

  ${props => props.filterBlock && StyledCandidatesPageWithFilters};
`;

export const StyledCandidatesToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px 0;
  min-height: 40px;
`;

export const StyledMiniChatToggleButton = styled.button<{ $active?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 6px 12px;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.BLUE.B400 : theme.colors.BORDER};
  border-radius: 8px;
  background: ${({ theme, $active }) =>
    $active ? theme.colors.BLUE.B400 : theme.colors.CARD};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.NEUTRAL.N0 : theme.colors.TITLE};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.colors.BLUE.B400};
    color: ${({ theme, $active }) =>
      $active ? theme.colors.NEUTRAL.N0 : theme.colors.BLUE.B400};
  }
`;

export const StyledMiniChatToggleBadge = styled.span`
  position: absolute;
  top: -3px;
  right: -3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.BLUE.B400};
  box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.CARD};
  pointer-events: none;
`;

export const StyledCandidatesCardBody = styled.div`
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

export const StyledMiniChatSlot = styled.div<{ $open: boolean }>`
  position: relative;
  flex-shrink: 0;
  align-self: stretch;
  width: ${({ $open }) => ($open ? `${MINI_CHAT_WIDTH}px` : '0px')};
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.BG};
  transition: width ${MINI_CHAT_TRANSITION_MS}ms ease;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};

  @media (max-width: 1100px) {
    width: 100%;
    height: ${({ $open }) =>
      $open ? `${MINI_CHAT_MOBILE_HEIGHT}px` : '0px'};
    transition: height ${MINI_CHAT_TRANSITION_MS}ms ease;
  }
`;

export const StyledCandidatesTablePane = styled.div<{ hasBadge: boolean }>`
  position: relative;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.CARD};

  ${StyledTableRows} {
    overflow-x: hidden;

    ${props =>
      props.hasBadge
        ? css`
            max-height: calc(100vh - 44px - 61px - 175px);
          `
        : css`
            max-height: calc(100vh - 44px - 61px - 140px);
          `};
  }

  @media (max-width: 1100px) {
    ${StyledTableRows} {
      ${props =>
        props.hasBadge
          ? css`
              max-height: calc(100vh - 44px - 61px - 175px - 160px);
            `
          : css`
              max-height: calc(100vh - 44px - 61px - 140px - 160px);
            `};
    }
  }
`;

export const StyledTableCreateButton = styled.div`
  ${StyledFloatButton} {
    position: absolute;
    right: 16px;
    bottom: 16px;
  }
`;

export const StyledAvailableRegions = styled.div`
  > div {
    height: 24px;
  }
`;

export const StyledNameWrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;
